module.exports = __webpack_public_path__ + "static/media/plasticos.61fea1b3.png";